import React, { Component } from "react";
import { getWebData } from "../../utils/common.utils";
import { CgNotes } from "react-icons/cg";

export default class TermAndConditions extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.websiteData = getWebData();
  }

  componentDidMount() {
    this.props.showOrHideNav(true);
  }

  render() {
    const policies =
      this.websiteData?.STATIC_PAGE?.TERMS_AND_CONDITIONS?.SET_UP_TERMS_AND_CONDITIONS?.split("&&");

    return (
      <section className="body-section">
        <div className="p-3 d-flex flex-column mx-auto notifications">
          <div className="row text-center">
            <div className="col-12">
              <h1 className="fs-20 fw-bold text-white mb-2 mt-3">
                {" "}
                <CgNotes style={{ color: "white" }} /> Term And Conditions
              </h1>
            </div>
          </div>
          <div className="row ">
            <ol className="text-white">
              {policies?.map((policy, i) => {
                return <li key={i}>{policy}</li>;
              })}
            </ol>
          </div>
        </div>
      </section>
    );
  }
}
